import { render, staticRenderFns } from "./u-card-border-top.vue?vue&type=template&id=4e576166&scoped=true"
import script from "./u-card-border-top.vue?vue&type=script&lang=js"
export * from "./u-card-border-top.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e576166",
  null
  
)

export default component.exports